import { IconButton, Avatar } from '@mui/material';
import { MouseEvent } from 'react';
import { selectUser } from 'renderer/features/auth/state/userSelectors';
import { useAppSelector } from 'renderer/shared/state/hooks';

interface UserAvatarProps {
  handleClick?: (event: MouseEvent<HTMLButtonElement>) => void;
}

const UserAvatar = ({ handleClick }: UserAvatarProps) => {
  const user = useAppSelector(selectUser);
  const initial =
    user && user.role === 'public'
      ? null
      : user && user.firstName.charAt(0).toUpperCase();
  return (
    <IconButton onClick={handleClick}>
      {/* <Avatar sx={{ bgcolor: '#1976D2' }}>{initial}</Avatar> */}
      <Avatar sx={{ bgcolor: 'primary.light' }}>{initial}</Avatar>
    </IconButton>
  );
};

export default UserAvatar;
